import { I18n } from "Utils/types";

export const Buttons: Record<string, I18n> = {
    about: {
        en: "about",
        he: "אודות",
    },
    projects: {
        en: "projects",
        he: "פרוייקטים",
    }
}